import { RequestOfferState } from './-types'

export default (): RequestOfferState => ({
  spaces: [],
  cartSpacesIsOpen: false
})
